import Header from "../components/Header";
import Footer from "../components/Footer";
import CaseStudies from "../components/CaseStudies";
import { useState, useEffect } from 'react';
import PaymentModal from "../components/showPaymentModel";
import Roi_calulator from "../components/Calculate_ROI";
import { openRazorpay } from "../utils/openRazorpay";
const TIMER_DURATION = 24 * 60 * 60 * 1000; // 24 hours in miliseconds

export default function Pricing() {
    const [showPayement, setShowPayment] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [selectedAmount, setSelectedAmount] = useState(0);

    // Handle payment after amount selection
    const handleStandardPayment = (amount) => {
        setSelectedAmount(amount);
        setSelectedPlan({ title: "Standard", amount });
        setShowPayment(true);
    };

    return (
        <div>
            <Header />

            {showPayement && (
                <PaymentModal
                    plan={selectedPlan}
                    onClose={() => setShowPayment(false)}
                    amount={selectedAmount}
                />
            )}

            {/* --- HERO SECTION --- */}
            <section className="relative pt-32 pb-20 px-4 overflow-hidden">
                <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-pink-100/50 blur-[120px] rounded-full -z-10" />
                <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-purple-100/40 blur-[100px] rounded-full -z-10" />

                <div className="max-w-6xl mx-auto text-center">
                    <h1 className="text-5xl md:text-7xl font-black text-gray-900 mb-6 tracking-tight">
                        Invest in <span className="text-sky-600/100">Growth</span>
                    </h1>
                    <p className="text-gray-500 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
                        The all-in-one platform to manage, track, and grow your business
                    </p>
                </div>

                {/* PRICING CARDS GRID */}
                <div className="flex flex-wrap justify-center gap-8 mt-20 max-w-7xl mx-auto">
                    <PricingCard
                        title="Standard"
                        setShowPayment={setShowPayment}
                        setSelectedPlan={setSelectedPlan}
                        setSelectedAmount={setSelectedAmount}
                        desc={[
                            "Full access to all features",
                            "Unlimited inventory items",
                            "Advanced purchase & sales",
                            "Multi-warehouse support",
                            "Priority support",
                        ]}
                        onStandardSelect={handleStandardPayment}
                        popular={true}
                        customization="DIY (Do It Yourself) Setup"
                    />

                    <PricingCard
                        title="Collaboration"
                        setShowPayment={setShowPayment}
                        setSelectedPlan={setSelectedPlan}
                        desc={[
                            "Full access to all features",
                            "Unlimited inventory items",
                            "Advanced purchase & sales",
                            "Multi-warehouse support",
                            "Priority support",
                            "Vendor performance tracking"
                        ]}
                        customization="Partially Customize"
                    />

                    <PricingCard
                        title="Enterprise"
                        setShowPayment={setShowPayment}
                        setSelectedPlan={setSelectedPlan}
                        desc={[]}
                        customization="We'll fully customize for you"
                    />
                </div>
            </section>

            {/* ================================================= */}
            {/* --- 3% SAVINGS SECTION --- */}
            {/* ================================================= */}

            {/* --- 3% SAVINGS SECTION --- */}
            <section className="py-24 px-6 bg-gradient-to-br from-slate-950 via-slate-900 to-blue-950 text-white">

                <div className="container mx-auto max-w-5xl">

                    <div className="text-center max-w-3xl mx-auto">

                        <span className="inline-flex items-center px-4 py-2 mb-5 rounded-full bg-blue-500/10 border border-blue-400/20 text-blue-300 text-xs font-bold tracking-widest uppercase">
                            WORKING CAPITAL IMPACT
                        </span>

                        <h2 className="text-3xl md:text-5xl font-black tracking-tight mb-5">
                            Unlock a Minimum 4%
                            <span className="block text-sky-400">
                                of Trapped Working Capital.
                            </span>
                        </h2>

                        <p className="text-slate-400 text-lg leading-relaxed max-w-2xl mx-auto">
                            Adeya helps manufacturers identify
                            <span className="text-white font-semibold">
                                {" "}excess, slow-moving and inefficient inventory
                            </span>
                            {" "}so you can reduce inventory and free up working capital.
                        </p>
                    </div>

                    {/* ₹10 Crore Example */}
                    <div className="mt-12 max-w-4xl mx-auto">

                        <div className="rounded-3xl bg-gradient-to-r from-sky-500 to-blue-600 p-8 md:p-12 text-center shadow-2xl shadow-blue-900/30">

                            <p className="text-blue-100 font-semibold text-sm uppercase tracking-wider mb-4">
                                Minimum 4% Potential Savings
                            </p>

                            <h3 className="text-5xl md:text-7xl font-black text-white mb-4">
                                ₹40,00,000
                            </h3>

                            <p className="text-blue-100 text-lg md:text-xl max-w-2xl mx-auto">
                                On a <span className="font-bold text-white">₹10 Crore inventory</span>,
                                representing a minimum
                                <span className="font-bold text-white"> 4% </span>
                                improvement in inventory efficiency.
                            </p>

                        </div>

                    </div>


                    <p className="text-center text-slate-500 text-xs md:text-sm mt-6 max-w-3xl mx-auto">
                        *Illustrative example based on a minimum 4% efficiency improvement.
                        Actual savings may vary depending on inventory value,
                        operations and business conditions.
                    </p>

                </div>

            </section>


            {/* --- ROI CALCULATOR --- */}
            <section id="roi_calculator">
                <Roi_calulator />
            </section>

            <section className="scroll-mt-32" id="case-studies">
                <CaseStudies />
            </section>
            <FAQSection />
            <Footer />
        </div>
    );
}

// ==================== PricingCard Component ====================
// function PricingCard({ title, desc, highlight, setShowPayment, setSelectedPlan, setSelectedAmount, onStandardSelect, customization }) {
//     const [showAmountModal, setShowAmountModal] = useState(false);

//     const handleClick = () => {
//         if (title === "Standard") {
//             // Open amount selection modal
//             setShowAmountModal(true);
//         } else if (title === "Collaboration" || title === "Enterprise") {
//             window.location.href = "/contact";
//         } else {
//             setSelectedPlan(title);
//             setShowPayment(true);
//         }
//     };

//     const selectAmount = (amount) => {
//         setShowAmountModal(false);
//         if (onStandardSelect) {
//             onStandardSelect(amount);
//         }
//         setSelectedPlan({ title, amount });
//         setShowPayment(true);
//     };

//     const getCostomizationColor = () =>{
//         switch(title){
//             case "Standard": return "bg-amber-100 text-amber-700 border-amber-200";
//             case "Collaboration": return "bg-blue-100 text-blue-700 border-blue-200";
//             case "Enterprise": return "bg-purple-100 text-purple-700 border-purple-200";
//             default: return "bg-gray-100 text-gray-700 border-gray-200";
//         }
//     }

//     return (
//         <>
//             <div className={`group relative w-[340px] rounded-2xl p-8 transition-all duration-500 ${
//                 highlight
//                     ? "bg-white border-2 border-blue-500 shadow-2xl scale-105 z-10"
//                     : "bg-white border border-slate-200 shadow-lg hover:shadow-xl"
//             } hover:-translate-y-2`}>

//                 {highlight && (
//                     <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-[10px] font-black px-5 py-1.5 rounded-full uppercase tracking-widest shadow-lg whitespace-nowrap">
//                         🔥 Most Popular
//                     </div>
//                 )}

//                 <h3 className="text-2xl font-bold text-slate-800 mb-2">{title}</h3>
//                 <p className={`inline-block text-xs font-semibold px-4 py-2 mb-2 rounded-full border ${getCostomizationColor()}`}>
//                     {customization}
//                 </p>

//                 <button
//                     onClick={handleClick}
//                     className={`w-full py-3 rounded-xl font-semibold transition-all duration-300 mb-8 ${
//                         highlight
//                             ? "bg-sky-500/100 text-white shadow-md hover:shadow-lg hover:-translate-y-0.5"
//                             : "bg-slate-200 text-slate-700 hover:bg-sky-500/100 hover:text-white shadow-sm hover:shadow-md hover:-translate-y-0.5"
//                     }`}
//                 >
//                     {title === "Standard" ? "Pay Now" : title === "Collaboration" || title === "Enterprise" ? "Contact Sales" : "Get Started"}
//                 </button>

//                 <div className="space-y-3 text-left">
//                     <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-3">
//                         ✓ Core Features
//                     </p>
//                     {desc.map((item, i) => (
//                         <div key={i} className="flex items-center gap-3 group/item">
//                             <div className={`w-5 h-5 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 ${
//                                 highlight 
//                                     ? "bg-blue-100 group-hover/item:bg-blue-500" 
//                                     : "bg-slate-100 group-hover/item:bg-blue-500"
//                             }`}>
//                                 <svg className={`w-3 h-3 transition-colors duration-300 ${
//                                     highlight ? "text-blue-600" : "text-slate-500"
//                                 } group-hover/item:text-white`} 
//                                 fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
//                                 </svg>
//                             </div>
//                             <span className="text-sm text-slate-600 font-medium group-hover/item:text-slate-900 transition-colors">
//                                 {item}
//                             </span>
//                         </div>
//                     ))}
//                 </div>
//             </div>

//             {/* Amount Selection Modal for Standard Plan */}
//             {showAmountModal && (
//                 <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
//                     <div className="bg-white rounded-2xl max-w-md w-full p-6 shadow-2xl">
//                         <div className="flex justify-between items-center mb-4">
//                             <h3 className="text-xl font-bold">Choose Plan - {title}</h3>
//                             <button onClick={() => setShowAmountModal(false)} className="text-slate-400 hover:text-slate-600">
//                                 ✕
//                             </button>
//                         </div>

//                         <div className="space-y-4">
//                             <div className="flex gap-4">
//                                 <button
//                                     onClick={() => selectAmount(4999)}
//                                     className="flex-1 border-2 rounded-lg p-4 text-center hover:border-blue-500 transition group"
//                                 >
//                                     <div className="font-bold text-lg text-slate-800">₹4,999</div>
//                                     <div className="text-sm text-slate-500">Monthly</div>
//                                 </button>
//                                 <button
//                                     onClick={() => selectAmount(9999)}
//                                     className="flex-1 border-2 rounded-lg p-4 text-center hover:border-blue-500 transition group"
//                                 >
//                                     <div className="font-bold text-lg text-slate-800">₹9,999</div>
//                                     <div className="text-sm text-slate-500">3 Months</div>
//                                     <div className="text-xs text-green-600 font-medium">Save ₹4,998</div>
//                                 </button>
//                             </div>

//                             <button
//                                 onClick={() => setShowAmountModal(false)}
//                                 className="w-full py-2 text-slate-500 hover:text-slate-700 text-sm"
//                             >
//                                 Cancel
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// }
// ==================== PricingCard Component ====================
function PricingCard({ title, desc, highlight, setShowPayment, setSelectedPlan, setSelectedAmount, onStandardSelect, customization }) {
    const [showAmountModal, setShowAmountModal] = useState(false);
    const [timeLeft, setTimeLeft] = useState(TIMER_DURATION);

    useEffect(() => {
        if (title !== "Standard") return;

        const storageKey = "adeya_offer_end_time";

        let endTime = localStorage.getItem(storageKey);


        if (!endTime || endTime <= Date.now()) {
            // endTime = Date.now() + TIMER_DURATION;
            endTime = Date.now() + TIMER_DURATION;
            localStorage.setItem(storageKey, endTime);
        }

        const updateTimer = () => {
            const remaining = Number(endTime) - Date.now();
            setTimeLeft(Math.max(0, remaining));
        };

        updateTimer();

        const interval = setInterval(updateTimer, 1000);

        return () => clearInterval(interval);
    }, [title]);

    const totalSeconds = Math.floor(timeLeft / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const formatTime = (value) => String(value).padStart(2, "0");

    const handleClick = async () => {
        if (title === "Standard") {
            await openRazorpay({ amount: 11999, plan: "Standard annual plan" });
        } else if (title === "Collaboration" || title === "Enterprise") {
            window.location.href = "/contact";
        } else {
            setSelectedPlan(title);
            setShowPayment(true);
        }
    };

    const selectAmount = (amount) => {
        setShowAmountModal(false);
        if (onStandardSelect) {
            onStandardSelect(amount);
        }
        setSelectedPlan({ title, amount });
        setShowPayment(true);
    };

    const getCustomizationColor = () => {
        switch (title) {
            case "Standard": return "bg-amber-100 text-amber-700";
            case "Collaboration": return "bg-blue-100 text-blue-700";
            case "Enterprise": return "bg-purple-100 text-purple-700";
            default: return "bg-gray-100 text-gray-700";
        }
    };

    // ✅ Button styles based on plan
    const getButtonStyles = () => {
        switch (title) {
            case "Standard":
                return "bg-sky-500/100 text-white shadow-md hover:shadow-lg hover:-translate-y-0.5";
            case "Collaboration":
                return "text-white bg-sky-500/100 shadow-sm hover:shadow-md hover:-translate-y-0.5";
            case "Enterprise":
                return "text-white bg-sky-500/100 shadow-sm hover:shadow-md hover:-translate-y-0.5";
            default:
                return "bg-slate-200 text-slate-700 hover:bg-sky-500/100 hover:text-white";
        }
    };

    return (
        <>
            <div className={`group relative w-[340px] rounded-2xl p-8 transition-all duration-500 bg-white border border-slate-200 shadow-lg hover:shadow-xl hover:border-sky-500 hover:-translate-y-2`}>

                <h3 className="text-2xl font-bold text-slate-800 mb-2">{title}</h3>

                <p className={`inline-block text-xs font-semibold px-4 py-2 mb-4 rounded-full ${getCustomizationColor()}`}>
                    {customization}
                </p>

                {/* ✅ Pricing Display */}
                {/* <div className="mb-4">
                    <span className="text-3xl font-black text-slate-900">
                        {title === "Standard" ? "₹4,999" : "Custom"}
                    </span>
                    {title === "Standard" && (
                        <span className="text-slate-400 text-sm ml-1">/month</span>
                    )}
                </div> */}
                {/* ✅ Pricing Display */}
                <div className="mb-4">

                    {title === "Standard" ? (
                        <>

                            {/* Offer Price */}
                            <div className="flex items-baseline gap-2 mt-1">
                                <span className="text-4xl font-black text-slate-900">
                                    ₹11,999
                                </span>

                                <span className="text-slate-400 text-sm">
                                    /year
                                </span>
                            </div>

                            {/* Original Price */}
                            {/* <div className="flex items-center gap-2">
                <span className="text-xl font-bold text-red-500 line-through decoration-2">
                    ₹7,999
                </span>

                <span className="text-slate-400 text-sm">
                    /month
                </span>
            </div> */}

                            {/* 24 Hour Offer */}
                            <div className="mt-4 rounded-xl bg-red-100 border border-red-100 p-3 text-center">

                                <p className="text-red-600 font-bold text-xs uppercase tracking-wide">
                                    Offer Available Only for 24 Hours
                                </p>

                                <div className="mt-2 text-2xl font-black text-slate-900 tracking-wider">
                                    {formatTime(hours)}:{formatTime(minutes)}:{formatTime(seconds)}
                                </div>

                                <p className="text-[10px] text-slate-400 mt-1">
                                    HOURS&nbsp;&nbsp; MINUTES&nbsp;&nbsp; SECONDS
                                </p>

                            </div>
                        </>
                    ) : (
                        <span className="text-3xl font-black text-slate-900">
                            Custom
                        </span>
                    )}

                </div>

                <button
                    onClick={handleClick}
                    className={`w-full py-3 rounded-xl font-semibold transition-all duration-300 mb-6 ${getButtonStyles()}`}
                >
                    {title === "Standard" ? "Pay Now" : "Contact Sales"}
                </button>

                {desc.length > 0 && (
                    <div className="space-y-3 text-left">
                        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-3">
                            ✓ Core Features
                        </p>
                        {desc.map((item, i) => (
                            <div key={i} className="flex items-center gap-3 group/item">
                                <div className="w-5 h-5 rounded-full bg-slate-100 flex items-center justify-center shrink-0 group-hover/item:bg-blue-500 transition-all duration-300">
                                    <svg className="w-3 h-3 text-slate-500 group-hover/item:text-white transition-colors duration-300"
                                        fill="none" viewBox="0 0 24 24" stroke11="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <span className="text-sm text-slate-600 font-medium group-hover/item:text-slate-900 transition-colors">
                                    {item}
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Amount Selection Modal for Standard Plan */}
            {/* {showAmountModal && (
                <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl max-w-md w-full p-6 shadow-2xl">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-xl font-bold">Choose Plan - {title}</h3>
                            <button onClick={() => setShowAmountModal(false)} className="text-slate-400 hover:text-slate-600">
                                ✕
                            </button>
                        </div>

                        <div className="space-y-4">
                            <div className="flex gap-4">
                                <button
                                    onClick={() => selectAmount(11999)}
                                    className="flex-1 border-2 rounded-lg p-4 text-center hover:border-amber-500 transition group"
                                >
                                    <div className="font-bold text-lg text-slate-800">₹11,999</div>
                                    <div className="text-sm text-slate-500">Year</div>
                                </button>
                                <button
                                    onClick={() => selectAmount(9999)}
                                    className="flex-1 border-2 rounded-lg p-4 text-center hover:border-amber-500 transition group"
                                >
                                    <div className="font-bold text-lg text-slate-800">₹9,999</div>
                                    <div className="text-sm text-slate-500">3 Months</div>
                                    <div className="text-xs text-green-600 font-medium">Save ₹4,998</div>
                                </button>
                            </div>

                            <button
                                onClick={() => setShowAmountModal(false)}
                                className="w-full py-2 text-slate-500 hover:text-slate-700 text-sm"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )} */}
        </>
    );
}

// ==================== FAQ Section ====================
function FAQSection() {
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            question: "How quickly can I set up Adeya IMS?",
            answer: `Most businesses are up and running within 1-2 days.

We provide:
• Easy onboarding process
• Data migration assistance
• Team training
• 24/7 support during setup

No complex IT skills required. Just sign up and start managing.`,
        },
        {
            question: "Is my business data secure with Adeya IMS?",
            answer: `Absolutely. Security is our top priority.

We provide:
• 256-bit bank-grade encryption
• Role-based access control
• Automated daily backups
• Secure cloud infrastructure
• GDPR compliant data handling

Your data stays yours. Always.`,
        },
        {
            question: "Can I manage multiple warehouses or locations?",
            answer: `Yes! Adeya IMS fully supports multi-warehouse management.

You can:
• Track stock across multiple locations
• Transfer inventory between warehouses
• Set location-specific reorder levels
• Generate consolidated or individual reports

Perfect for businesses with multiple storage facilities.`,
        },
        {
            question: "What reports and analytics are available?",
            answer: `Get complete visibility with our advanced reporting suite:

• Stock valuation reports
• Purchase & sales summaries
• Profit & loss statements
• Vendor performance analytics
• Low stock & expiry alerts
• Custom date range reports

Make data-driven decisions with real-time insights.`,
        },
        {
            question: "What kind of customer support do you provide?",
            answer: `We're here to help you succeed.

Support options:
• Email support for all plans
• Priority chat for Professional plan
• 24/7 dedicated support for Enterprise
• Knowledge base & video tutorials
• Onboarding training included

Our team responds within 2 hours on business days.`,
        },
        {
            question: "What about the pricing of Adeya IMS?",
            answer: null,
        },
        {
            question: "What makes Adeya IMS different from other inventory management systems?",
            answer: `Most inventory systems just track stock. Adeya IMS helps you manage your entire business operations.

• Real-time inventory tracking
• Purchase order automation
• Sales analytics & invoicing
• Vendor performance management
• Smart reordering alerts
• Multi-warehouse support

It's an all-in-one platform designed to save you time and money.`,
        },
    ];

    // Split FAQs into two columns evenly
    const midIndex = Math.ceil(faqs.length / 2);
    const leftFAQs = faqs.slice(0, midIndex);
    const rightFAQs = faqs.slice(midIndex);

    return (
        <section className="py-20 px-4 bg-gradient-to-b from-white to-slate-50">
            <div className="max-w-6xl mx-auto">
                <div className="text-center mb-12">
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                        Frequently Asked Questions
                    </h2>
                    <p className="text-gray-500 text-lg">
                        Everything you need to know about Adeya IMS
                    </p>
                </div>

                {/* Two Column Grid - Perfect Alignment */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Left Column */}
                    <div className="space-y-5">
                        {leftFAQs.map((faq, index) => (
                            <FAQItem
                                key={index}
                                faq={faq}
                                isOpen={openIndex === index}
                                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                            />
                        ))}
                    </div>

                    {/* Right Column */}
                    <div className="space-y-5">
                        {rightFAQs.map((faq, index) => (
                            <FAQItem
                                key={midIndex + index}
                                faq={faq}
                                isOpen={openIndex === (midIndex + index)}
                                onClick={() => setOpenIndex(openIndex === (midIndex + index) ? null : (midIndex + index))}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

// ==================== FAQItem Component ====================
function FAQItem({ faq, isOpen, onClick }) {
    return (
        <div
            onClick={onClick}
            className={`rounded-xl p-5 cursor-pointer transition-all duration-300
                ${isOpen
                    ? "border border-blue-200 shadow-lg bg-gradient-to-br from-blue-50/50 to-white"
                    : "bg-white shadow-md border border-slate-200 hover:shadow-lg"
                }`}
        >
            <div className="flex items-start gap-3">
                <span className={`text-xl font-bold w-5 shrink-0 transition-colors ${isOpen ? "text-blue-600" : "text-gray-600"}`}>
                    {isOpen ? "−" : "+"}
                </span>

                <div className="w-full">
                    <h3 className={`font-semibold text-base ${isOpen ? "text-blue-700" : "text-gray-800"}`}>
                        {faq.question}
                    </h3>

                    {isOpen && (
                        <div className="mt-3 text-sm text-gray-800 leading-relaxed">
                            {faq.answer ? (
                                <p className="whitespace-pre-line">{faq.answer}</p>
                            ) : (
                                <div className="flex flex-wrap gap-3 mt-2">
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            window.location.href = "/pricing";
                                        }}
                                        className="px-5 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-sm font-medium rounded-lg hover:shadow-md transition"
                                    >
                                        View Pricing Plans
                                    </button>
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            window.location.href = "/contact";
                                        }}
                                        className="px-5 py-2 bg-slate-100 text-slate-700 text-sm font-medium rounded-lg hover:bg-slate-200 transition"
                                    >
                                        Contact Sales
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}